import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Modal from './Modal';
import Spinner from './Spinner';
import clsx from 'clsx';

const confirmButtonVariants = {
  danger:   'bg-error-600 text-white hover:bg-error-700 focus-visible:ring-error-500',
  primary:  'bg-primary-600 text-white hover:bg-primary-700 focus-visible:ring-primary-500',
  warning:  'bg-warning-600 text-white hover:bg-warning-700 focus-visible:ring-warning-500',
  success:  'bg-success-600 text-white hover:bg-success-700 focus-visible:ring-success-500',
};

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  confirmVariant = 'danger',
  loading = false,
}) {
  const btnClasses = confirmButtonVariants[confirmVariant] ?? confirmButtonVariants.danger;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="flex flex-col items-center gap-4 text-center">
        {/* Icon */}
        <div
          className={clsx(
            'flex h-12 w-12 items-center justify-center rounded-full',
            confirmVariant === 'danger' ? 'bg-error-100' : 'bg-warning-100'
          )}
        >
          <ExclamationTriangleIcon
            className={clsx(
              'h-6 w-6',
              confirmVariant === 'danger' ? 'text-error-600' : 'text-warning-600'
            )}
            aria-hidden="true"
          />
        </div>

        {/* Text */}
        <div>
          <h3 className="text-base font-semibold text-neutral-900 font-heading">{title}</h3>
          {message && (
            <p className="mt-1.5 text-sm text-neutral-500">{message}</p>
          )}
        </div>

        {/* Actions */}
        <div className="mt-1 flex w-full gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="flex-1 rounded-button border border-neutral-200 bg-white px-4 py-2.5 text-sm font-medium text-neutral-700 transition hover:bg-neutral-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={clsx(
              'flex flex-1 items-center justify-center gap-2 rounded-button px-4 py-2.5 text-sm font-medium shadow-button transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 disabled:opacity-60',
              btnClasses
            )}
          >
            {loading && <Spinner size="sm" className="text-white" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
